import React from 'react';

const YouTubeEmbed = (props: { title: string; url: { url: string } }) => {
	return (
		<div
			style={{
				position: 'relative',
				width: '100%',
				paddingTop: '56.25%',
			}}
		>
			<iframe
				title={props.title}
				style={{
					position: 'absolute',
					width: '100%',
					height: '100%',
					left: '0',
					top: '0',
				}}
				width="560"
				height="315"
				src={props.url.url}
				frameBorder="0"
				allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
				allowFullScreen
			/>
		</div>
	);
};

export default YouTubeEmbed;
